"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ProductGroup = ProductGroup;

var _react = _interopRequireDefault(require("react"));

var _ProductCard = require("./ProductCard");

function ProductGroup(props) {
  var productGroups = props.productGroups;
  return _react.default.createElement(_react.default.Fragment, null, productGroups && productGroups.edges.map(function (productGroupEdge) {
    var productGroup = productGroupEdge.node;
    return _react.default.createElement(_ProductCard.ProductCard, {
      key: productGroup.id,
      title: productGroup.title,
      products: productGroup.product
    });
  }));
}